<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import commonTop from '@/components/commonTop.vue'
import moment from 'moment'

export default {
    components: { commonTop },
    data() {
        return {
            commonTopData: {
                "pageName": "holdAll",
                "commonleftbtn": [],
                "commonrightbtn": [],
                "commonbottombtn":[],
            },
            form: {},
            personnels: [],
            timeRange: [],
            businessList: [],
            loading: false,
            disabled: false,
            pageType: ''
        };
    },
    methods: {
        init() {
            this.getPermissionBusiness()
            this.getPermissionUserList()

            let { pageType, id } = this.$route.query
            this.pageType = pageType

            if(pageType === 'view' || pageType === 'edit') {
                this.permissionInfo()

                if(pageType === 'view') {
                    this.disabled = true
                }else if(pageType === 'edit') {
                    this.form.id = id
                }
            }
        },
        async permissionInfo() {
            let data = await this.api.permissionList({
                id: this.$route.query.id
            })
            data = data.data[0]

            if(data) {
                let { adminName: personneId, permissionIds, startTime, endTime } = data

                this.$set(this.form, 'personneId', personneId)
                this.$set(this.form, 'permissionIds', permissionIds.split(','))

                this.timeRange = [startTime, endTime]
            }
        },
        async getPermissionBusiness() {
            this.businessList = await this.api.getPermissionBusiness()
            this.businessList.unshift({ permisionIds: -1, permissionName: '全部业务' })
        },
        async getPermissionUserList(word) {
            try {
                let data = await this.api.getPermissionUserList({ name: word })

                this.personnels = data.data
                this.loading = true
            } finally {
                this.loading = false
            }
        },
        // 更新、新增临时分配权限
        async permissionAdd() {
            let { personneId, permissionIds = [], id } = this.form

            if(!personneId) {
                this.$message.error('请选择分配人员')
            }else if(!permissionIds.length) {
                this.$message.error('请选择业务类型')
            }else if(!this.timeRange.length) {
                this.$message.error('请选择权限有效期')
            }else {
                const personnel = this.personnels.find(item => item.name === personneId)
                const permissionNames = this.businessList.filter(item => permissionIds.includes(item.permisionIds)).map(item => item.permissionName)

                if(permissionIds.includes(-1)) {
                    permissionIds = this.businessList.map(item => item.permisionIds)
                }

                await this.api[this.pageType === 'edit' ? 'permissionUpdate' : 'permissionAdd']({
                    id,
                    adminName: personnel.name,
                    adminEmail: personnel.email,
                    permissionName: permissionNames.join(','),
                    permissionIds: permissionIds.join(','),
                    startTime: moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm:ss'),
                    endTime: moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm:ss')
                })

                this.$message.success(`${this.pageType === 'edit' ? '修改' : '新增'}成功`)
                this.$router.back()
            }
        }
    },
    created() {
        this.init()
    },
};
</script>
